import { render, staticRenderFns } from "./BlockEditorPageRoot.vue?vue&type=template&id=5c75d4e3&scoped=true&"
import script from "./BlockEditorPageRoot.vue?vue&type=script&lang=js&"
export * from "./BlockEditorPageRoot.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditorPageRoot.vue?vue&type=style&index=0&id=5c75d4e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75d4e3",
  null
  
)

export default component.exports